import type { ReactNode } from 'react';
import { Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { APP_LINK_STATE } from '../../Home/navRoutes';
import { COLORS } from '../../IndividualPlan/tokens';
import { studentsHref } from '../listKeys';

export function CountLink({
  count,
  listKey,
  children,
  testId,
}: {
  count: number;
  listKey: string;
  children?: ReactNode;
  testId?: string;
}) {
  const label = children ?? String(count);
  if (count <= 0) {
    return <span data-testid={testId}>{label}</span>;
  }
  return (
    <Link
      component={RouterLink}
      to={studentsHref(listKey)}
      state={APP_LINK_STATE}
      underline="hover"
      data-testid={testId}
      sx={{ color: COLORS.link, fontWeight: 600 }}
    >
      {label}
    </Link>
  );
}
